import { Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/** Centered loader for lazy pages (`fullScreen` for the boot / auth check). */
export function PageLoader({ fullScreen = false, label }: { fullScreen?: boolean; label?: string }) {
  const { t } = useTranslation();
  return (
    <Center h={fullScreen ? '100dvh' : 240} role="status" aria-live="polite">
      <Stack align="center" gap="xs">
        <Loader />
        <Text size="sm" c="dimmed">
          {label ?? t('common:states.loading')}
        </Text>
      </Stack>
    </Center>
  );
}
